export function tokenizeAddressForRdv(value) {
  return (value || "")
    .split(/\s+/)
    .map((t) => t.trim())
    .filter(Boolean);
}

export function trainRdvRowKey(r) {
  if (!r) return "";
  if (r._synthetic) return `synth:${(r.rname || "").trim()}`;
  return r.id != null && r.id !== ""
    ? `id:${Number(r.id)}`
    : `name:${(r.rname || "").trim()}`;
}

export function buildTrainRdvPartition(rdvList, dsRows, locationHint) {
  const list = Array.isArray(rdvList) ? rdvList : [];
  const dsArr = Array.isArray(dsRows) ? dsRows : [];
  const used = new Set();
  const primary = [];

  const pushUnique = (row) => {
    const k = trainRdvRowKey(row);
    if (!k || used.has(k)) return;
    used.add(k);
    primary.push(row);
  };

  if (dsArr.length > 0) {
    for (const row of dsArr) {
      const rid = row.rdv_id;
      const rname = (row.rname || "").trim();
      let m = null;
      if (rid != null && rid !== "" && !Number.isNaN(Number(rid))) {
        m = list.find((r) => Number(r.id) === Number(rid));
      }
      if (!m && rname) m = list.find((r) => (r.rname || "").trim() === rname);
      if (m) pushUnique(m);
      else if (rname) pushUnique({ id: null, rname, _synthetic: true });
    }
    const secondary = list.filter((r) => !used.has(trainRdvRowKey(r)));
    return { primary, secondary, showMore: secondary.length > 0 };
  }

  const parts = tokenizeAddressForRdv((locationHint || "").trim());
  if (parts.length === 0) {
    return { primary: list, secondary: [], showMore: false };
  }
  const topLevelRegion = parts[0];
  const localAreaTokens = parts.slice(1);
  const matched = list.filter((rdv) => {
    const sigun = (rdv.sigun || "").trim();
    const rdvAddress = (rdv.raddr || "").trim();
    if (!sigun && !rdvAddress) return false;
    if (sigun && parts.some((token) => token.includes(sigun))) return true;
    if (
      rdvAddress &&
      localAreaTokens.some((token) => rdvAddress.includes(token))
    ) {
      return true;
    }
    return rdvAddress.includes(topLevelRegion);
  });
  if (matched.length === 0) {
    return { primary: list, secondary: [], showMore: false };
  }
  const mset = new Set(matched.map((r) => trainRdvRowKey(r)));
  const primaryOrdered = list.filter((r) => mset.has(trainRdvRowKey(r)));
  const secondary = list.filter((r) => !mset.has(trainRdvRowKey(r)));
  return {
    primary: primaryOrdered,
    secondary,
    showMore: secondary.length > 0,
  };
}

export const TRAIN_RDV_OPT_EXPAND = "__mfm_train_rdv_expand__";
export const TRAIN_RDV_OPT_COLLAPSE = "__mfm_train_rdv_collapse__";
